export default "__VITE_ASSET__CySbzT9S__"